import * as React from 'react';

import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {Trans, useTranslation} from "react-i18next";
import CartManager, {
    getDiscountedPrice,
    useCartChange
} from "../../managers/cartManager/cartManager";
import AddressShowBox from "./shipping/AddressShowBox";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import {Link} from "react-router";
import NTPLogo from "ntp-logo-react";
import LockerCard from "./shipping/LockerCard";
import UserInfo from "./billingData/UserInfo";
import ShippingDays from "./shipping/ShippingDays";
import {logGAEvent} from "../../firebaseConfig/firebaseConfig";
import {useEffect} from "react";


export default function Review({accepted, setAccepted}) {
    const {t} = useTranslation();
    const cart = useCartChange();

    useEffect(() => {
        if (cart && cart.cartId) {
            logGAEvent('at_review_page', cart);
        }
    }, [cart?.id])

    const totalPrice = getDiscountedPrice(cart);
    const shippingPrice = CartManager.getShippingPrice();
    const shipping = CartManager.getShipping();
    const invoiceData = CartManager.getInvoiceData();

    return (
        <Stack spacing={2}>
            <List disablePadding>
                <ListItem sx={{py: 1, px: 0}}>
                    <ListItemText primary={t('cart.products')}
                                  secondary={t('reviewPage.selected', {nr: CartManager.getTotalNumberOfItems()})}/>
                    <Typography variant="body2">{totalPrice.toFixed(2)} Lei</Typography>
                </ListItem>
                <ListItem sx={{py: 1, px: 0}}>
                    <ListItemText primary={t('cart.shipping')} secondary={t(`shippingForm.${shipping.type}`)}/>
                    <Typography variant="body2">{shippingPrice.toFixed(2)} Lei</Typography>
                </ListItem>
                <ListItem sx={{py: 1, px: 0}}>
                    <ListItemText primary={t('cart.total')}/>
                    <Typography variant="subtitle1" sx={{fontWeight: 700}}>
                        {(totalPrice + shippingPrice).toFixed(2)} Lei
                    </Typography>
                </ListItem>
            </List>
            <Divider/>
            <Stack
                direction="column"
                divider={<Divider flexItem/>}
                spacing={2}
                sx={{my: 2}}
            >
                <div>
                    <Typography variant="subtitle2" gutterBottom>
                        <Trans i18nKey={'reviewPage.shippment'}/>
                    </Typography>
                    <ShippingDays/>
                    {shipping.type === 'normal' && <AddressShowBox address={shipping.address}/>}
                    {shipping.type === 'easyBox' && <LockerCard locker={shipping.easyBox}/>}
                    {shipping.type === 'personal' && <Typography>
                        <Trans i18nKey={'shippingForm.personal'}/>
                    </Typography>}
                </div>
                <div>
                    <Typography variant="subtitle2" gutterBottom>
                        <Trans i18nKey={'reviewPage.invoice'}/>
                    </Typography>
                    <AddressShowBox address={invoiceData.userInfo} showFirmData={invoiceData.type !== UserInfo.types.NATURAL_PERSON}/>
                </div>
                <div>
                    <Typography variant="subtitle2" gutterBottom>
                        <Trans i18nKey={'reviewPage.payment'}/>
                    </Typography>
                    {CartManager.getPaymentType() === 'creditCard' ?
                        <NTPLogo color="#ffffff" version="orizontal" secret="148502"/>
                        : <Typography><Trans i18nKey={`paymentForm.${CartManager.getPaymentType()}`}/></Typography>}
                </div>
            </Stack>
            <Divider/>
            <FormControlLabel
                sx={{px: 0, marginTop: 0, '& .MuiCheckbox-root': {pl: 0}}}
                control={<Checkbox name="saveAddress" value="yes"/>}
                label={<>{t('reviewPage.accept')}<Link
                    style={{textDecoration: 'none', color: 'initial', fontWeight: 500, cursor: 'pointer'}}
                    to="/terms-and-conditions"><Trans i18nKey={'reviewPage.termsAndConditions'}></Trans></Link></>}
                onChange={(event) => setAccepted(event.target.checked)}
                checked={accepted}
            />
        </Stack>
    );
}
